import { Box, Card, Divider, Typography } from "@mui/material";
import React from "react";

import { type ClientAppDto } from "@/modules/clientApps";

interface ClientAppFieldProps {
  clientApp: ClientAppDto;
}

const KEYS_LIST = ["name", "title", "email", "id"];

const InfoField = ({ label, value }: { label: string; value: string }) => (
  <Box sx={{ p: 1, display: "flex", gap: "0 4px", flexWrap: "wrap" }}>
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      {label}:
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

export const ClientAppField = ({ clientApp }: ClientAppFieldProps) => (
  <Card variant="outlined">
    {KEYS_LIST.map((key, index) => (
      <React.Fragment key={key}>
        <InfoField
          label={key.charAt(0).toUpperCase() + key.slice(1)}
          value={clientApp[key as keyof typeof clientApp]?.toString() ?? "N/A"}
        />
        {index < KEYS_LIST.length - 1 && <Divider />}
      </React.Fragment>
    ))}
  </Card>
);
